var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapterra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64.91,
    height: 66.28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m44,0l22,0l0,66.28125l-22,0l0,-66.28125zm0,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m27,24l18,0l0,42.28125l-18,0l0,-42.28125zm0,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m71,11l228.91016,0l0,55.28125l-228.91016,0l0,-55.28125zm0,0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fillRule: "nonzero",
    fill: "rgb(95.298767%,66.299438%,28.599548%)",
    d: "m0,24.37109l27.48828,0.00391l16.71485,0.00391l0,-16.5586l-44.20313,16.55078"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    clipRule: "nonzero",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fillRule: "nonzero",
    fill: "rgb(27.49939%,75.698853%,92.89856%)",
    d: "m44.20313,7.82031l0,58.46094l20.875,-66.27734l-20.875,7.8164zm0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    clipRule: "nonzero",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fillRule: "nonzero",
    fill: "rgb(0%,42.698669%,60.398865%)",
    d: "m44.20313,24.37891l-16.71485,-0.00391l16.71485,41.90625l0,-41.90234zm0,0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fillRule: "nonzero",
    fill: "rgb(87.098694%,41.598511%,39.199829%)",
    d: "m0,24.37109l31.77344,10.75782l-4.28516,-10.75391l-27.48828,-0.00391zm0,0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapterra);
export default __webpack_public_path__ + "static/media/capterra.777e1fe43effd2b9254bbacecce83063.svg";
export { ForwardRef as ReactComponent };